import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import ShowLoading from '../helperComponent/ShowLoading';
import courseImg from '../../assets/graduation.png';
import AddSection from './AddSection';

const CoursePageId = () => {
  const [course, setCourse] = useState([]);
  const [sections, setSections] = useState([]);
  const [buttonText, setButtonText] = useState('Add Section');
  const [addButton, setAddButton] = useState(false);

  const { id } = useParams();
  let history = useHistory();
  const uname = JSON.parse(localStorage.getItem('uname'));
  const url = 'https://stucharge.bakersbrisk.com';
  const fetchURL = `https://stucharge.bakersbrisk.com/api/singlecourseapi?username=${uname}&id=${id}`;

  const AuthStr = process.env.REACT_APP_AUTH_STR;

  // fetch data
  useEffect(() => {
    axios
      .get(fetchURL, { headers: { Authorization: AuthStr } })
      .then((response) => {
        // If request is good...
        if (response) {
          setCourse(response.data);
          setSections(response.data.course_sections);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchURL]);

  //delete handler
  const handleDelete = (key) => {
    const deleteURL = `https://stucharge.bakersbrisk.com/api/sectionapi?username=${uname}&id=${key}`;
    Swal.fire({
      title: 'Are you sure? Section will be deleted permanantly',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteSection(deleteURL);

        Swal.fire('Section deleted!', '', 'success').then((result) => {
          if (result.isConfirmed || !result.isConfirmed) {
            history.push('/courses');
            history.push(`/courses/${id}`);
          }
        });
      } else if (result.isDenied) {
        Swal.fire('Section not deleted!', '', 'info');
      }
    });
  };
  // making delete request
  const deleteSection = async (deleteURL) => {
    console.log(deleteURL);
    const res = await axios.delete(deleteURL, {
      headers: { Authorization: AuthStr },
    });
    if (res.status !== 200) {
      Swal.fire('Error deleting data!', '', 'error');
    }
  };

  //update handler
  const handleUpdate = (key) => {
    Swal.fire({
      title: 'Edit Title',
      html: `<input type="text" id="title" class="swal2-input" placeholder="Enter New Title">`,
      confirmButtonText: 'Confirm',
      focusConfirm: false,
      showDenyButton: true,
      denyButtonText: 'Cancel',
      preConfirm: () => {
        const title = Swal.getPopup().querySelector('#title').value;
        if (title === '') {
          Swal.fire('You need to write something', '', 'error');
        } else {
          var formData = new FormData();
          formData.append('title', title);
          updateClass(formData, key);
        }
      },
    }).then((result) => {
      if (result.isDenied) {
        Swal.fire('Section not updated!', '', 'info');
      }
    });
  };

  async function updateClass(bodyFormData, key) {
    const updateURL = `https://stucharge.bakersbrisk.com/api/sectionapi?username=${uname}&id=${key}`;
    const requestOptions = {
      method: 'PUT',
      headers: { Authorization: AuthStr },
      body: bodyFormData,
    };
    fetch(updateURL, requestOptions)
      .then(async (response) => {
        const data = await response.json();
        // check for error response
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        Swal.fire('Section updated successfully!', '', 'success').then(
          (result) => {
            if (result.isConfirmed || !result.isConfirmed) {
              history.push('/home');
              history.push(`/courses/${id}`);
            }
          }
        );
      })
      .catch((error) => {
        Swal.fire('Error updating data', '', 'error');
      });
  }

  const onClickHandler = () => {
    setAddButton(!addButton);
    setButtonText(buttonText === 'Add Section' ? 'Close' : 'Add Section');
  };

  return (
    <div className='main course'>
      <div className='main_container' style={{ background: '#fff' }}>
        <div className='main_title course'>
          <img src={courseImg} alt='hello' width='50' />
          <div className='main_greeting'>
            <h1>{course.title}</h1>
          </div>
        </div>

        <div className='overview'>
          <div className='left'>
            <img src={url + course.image} alt='course' />
          </div>
          <div className='right'>
            <p className='text-display'>
              {course.description ? course.description : <ShowLoading />}
            </p>
            <div className='pricing'>
              <h3 className='text-green'>Price ₹{course.price}</h3>
              <h3 className='text-oyellow'>
                Offer Price ₹{course.offer_price}
              </h3>
            </div>
          </div>
        </div>
        <hr />

        <div className='section-overview'>
          <div className='overview-heading'>
            <h1 className='text-title'>
              <i class='fas fa-chart-pie'></i>Section Overview
            </h1>
          </div>

          <div className='add-notes'>
            <button
              onClick={onClickHandler}
              style={{
                background: addButton ? '#ef4f4f' : '#ff7171',
              }}
            >
              {buttonText}
            </button>
          </div>

          {addButton && <AddSection id={id} />}

          {sections.length > 0 ? (
            <div className='table-container' style={{ margin: '0 auto' }}>
              <table className='table' style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>Lectures</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {sections.map((item, index) => (
                    <tr key={item.id} style={{ transform: 'none' }}>
                      <td data-label='#'>{index + 1}</td>
                      <td data-label='Title' className='text-title'>
                        {item.title}
                      </td>
                      <td data-label='Lectures'>
                        <a
                          href={`/courses/section/${item.id}`}
                          className='bttn view'
                          rel='noreferrer noopener'
                        >
                          View
                        </a>
                      </td>
                      <td data-label='Edit'>
                        <button
                          onClick={() => handleUpdate(item.id)}
                          className='bttn update'
                          rel='noreferrer noopener'
                        >
                          Edit
                        </button>
                      </td>
                      <td data-label='Delete'>
                        <button
                          onClick={() => handleDelete(item.id)}
                          className='bttn delete'
                          rel='noreferrer noopener'
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <h1
              className='text-oyellow'
              style={{ textAlign: 'center', margin: '10px' }}
            >
              No section added
            </h1>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoursePageId;
